<template>
  <div class="tour">
    <step
      v-if="steps[currentStep]"
      :step="steps[currentStep]"
      :key="currentStep"
      :currentStep="currentStep"
      :numberOfSteps="numberOfSteps"
      :previous-step="previousStep"
      :next-step="nextStep"
      :stop="stop"
      :is-first="isFirst"
      :is-last="isLast"
      @targetNotFound="targetNotFound($event)"
    >
    </step>
  </div>
</template>

<script>
import Step from './Step'
import notify from '../../utils/mixin-notify'

export default {
  name: 'Tour',
  mixins: [notify],
  components: {
    Step,
  },
  props: {
    steps: {
      type: Array,
      default: () => [],
    },
    name: {
      type: String,
    },
    startTour: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentStep: -1,
    }
  },
  computed: {
    isRunning() {
      return this.currentStep > -1 && this.currentStep < this.numberOfSteps
    },
    isFirst() {
      return this.currentStep === 0
    },
    isLast() {
      return this.currentStep === this.steps.length - 1
    },
    numberOfSteps() {
      return this.steps.length
    },
    step() {
      return this.steps[this.currentStep]
    },
  },
  methods: {
    start(startStep) {
      startStep = typeof startStep !== 'undefined' ? parseInt(startStep, 10) : 0
      this.currentStep = startStep
      this.removeSticky()
      document.body.classList.add('tour--active')
    },
    previousStep() {
      const futureStep = this.currentStep - 1
      if (futureStep > -1) this.currentStep = futureStep
    },
    nextStep() {
      const futureStep = this.currentStep + 1
      if (futureStep < this.numberOfSteps && this.currentStep !== -1) {
        this.currentStep = futureStep
      }
    },
    stop() {
      this.currentStep = -1
      this.$emit('stopTour')
      document.body.classList.remove('tour--active')
    },
    removeSticky() {
      document.querySelectorAll('.tableFixHead thead tr th, tr.twoHeader th').forEach((element) => {
        element.style['position'] = 'unset'
      })
    },
    targetNotFound(event) {
      this.showNotification({
        title: 'step_not_found',
        type: 'warning',
      })
    },
  },
  watch: {
    startTour(value) {
      if (value) this.start()
    },
  },
}
</script>

<style lang="scss">
body.tour--active {
  pointer-events: none;
}
.tour {
  pointer-events: auto;
}
</style>
